<template>
  <div>
    <b>{{filter.values.comparison_one.label}}</b> {{filter.values.threshold_one}}
    <template v-if="filter.values.comparison_two && filter.values.threshold_two">
    and <b>{{filter.values.comparison_two.label}}</b> {{filter.values.threshold_two}}
    </template>
  </div>
</template>
<script>
  export default {
    props: {
      filter: Object
    },
    name: 'NumericRangeParamsTemplate'
  }
</script>
<style>
</style>